module.exports = __webpack_public_path__ + "img/logo-white.7e4ca8bb.svg";